import { useLocalization } from "@/data/Localization";
import { Stack, Checkbox, Typography } from "@mui/material";
import { ChangeEvent, FC, useContext, useEffect, useMemo } from "react";
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { LatLng } from "@/data/types/Store";
import { ContentContext } from "@/data/context/content";
import { useClickAndCollect } from "@/data/Content/ClickAndCollect";

type Props = {
    setLatLng: (value: LatLng) => void
}

export const StoreListActions: FC<Props> = ({setLatLng}) => {
    
    const clickAndCollectNLS = useLocalization("ClickAndCollect");
    const {
        handleShowNearStoresCheckChange,
        stores,
        showSearchByLocation,
        setShowSearchByLocation,
        showSearchNearStores,
        isLoading:isCCLoading,
        setStores,
        setDisplayStores,
        setLocationAccess
    } = useContext(ContentContext) as ReturnType<typeof useClickAndCollect>;

    useEffect(()=>{
        const showNearStoreChkbox = document?.getElementById('cc-select-nearby-stores-pdp') as HTMLInputElement;
        if(showNearStoreChkbox?.checked)showNearStoreChkbox.click();
    },[stores]);
    
    const handleSeachByocationChange = (event:ChangeEvent<HTMLInputElement>) => {
        const checked = event.target.checked;
        setShowSearchByLocation(checked);
        if(checked){
            setStores([]);
            setDisplayStores([]);
            navigator.geolocation.getCurrentPosition(
                async (position: GeolocationPosition) => {
                    setLatLng({ lat: position.coords.latitude, lng: position.coords.longitude });
                    //clearSearchTermAndCloseEverything();
                    setLocationAccess(true);
                },
                (err: any) => {
                    //logError(undefined, 'StoreLocator: findNearStore: error: %o', err);
                }
            );
        }
        
    }

    const cursor = useMemo(()=>isCCLoading ? 'wait' : 'pointer',[isCCLoading]);

    return (
        <Stack rowGap={1}>
            <Stack direction="row" alignItems="center" columnGap={1}>
                <Checkbox
                    checked={showSearchByLocation}
                    onChange={(event: ChangeEvent<HTMLInputElement>) => handleSeachByocationChange(event)}
                    checkedIcon={<CheckBoxIcon />}
                    sx={{ p: 0, cursor }}
                    id="cc-search-with-current-location-pdp"
                    disabled={isCCLoading}
                />
                <Typography component={"label"} htmlFor="cc-search-with-current-location-pdp" sx={{ cursor }}>
                    {clickAndCollectNLS.SearchByLocation.t()}
                </Typography>
            </Stack>
            <Stack direction="row" alignItems="center" columnGap={1}>
                <Checkbox
                    onChange={(event: ChangeEvent<HTMLInputElement>) => handleShowNearStoresCheckChange(event)}
                    checkedIcon={<CheckBoxIcon />}
                    checked={showSearchNearStores}
                    sx={{ p: 0, cursor }}
                    id="cc-select-nearby-stores-pdp"
                    disabled={isCCLoading}
                />
                <Typography component={"label"} htmlFor="cc-select-nearby-stores-pdp" sx={{ cursor }}>
                    {clickAndCollectNLS.ShowNearestStoresWithStock.t()}
                </Typography>
            </Stack>
        </Stack>
    );
}